import React from 'react';

export default {
	path: '/rentalContract',
	components: () => [import(/* webpackChunkName: 'rentalContract' */ './component')],
	render: ([RentalContract]) => <RentalContract />,
};
